export default __webpack_public_path__ + "static/5-safety-tips-when-connecting-to-wifi-overseas-public-f41e293816762c58a7293a46181d8812.jpg";